import { resource } from "./resource";

const api = resource("/grade-level");

export const getGradeLevels = async () => await api.get();
export const createGradeLevel = async (input = {}) => await api.post("", input);
export const updateGradeLevel = async (id, input = {}) => await api.put(`/${id}`, input);
export const deleteGradeLevel = async (id) => await api.del(`/${id}`);
